import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/list-duck";
import { Picking } from "interfaces/picking";

const { Types, Creators } = createActions(
  {
    request: ["query", "onSuccess"],
    success: ["data"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "EXPORT_PICKINGS_" }
);

export interface ExportPickingsState extends IState {
  data: Picking[];
}

interface ISuccessExportUnitsAction extends ISuccessAction {
  data: Picking[];
}

const INITIAL_STATE: ExportPickingsState = {
  data: [],
  loading: false,
  error: null,
};

const request = (state: ExportPickingsState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: ExportPickingsState, action: ISuccessExportUnitsAction) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (state: ExportPickingsState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const exportPickings = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const ExportPickingsTypes = Types;
export const ExportPickingsActions = Creators;
